import {applyMiddleware, createStore} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension/developmentOnly'
import {handleOpenLink, handleFuture, inject, handleOpenLinkHere} from './middleware'
import reducer from './reducer'

import * as app from './app/actions'
import * as formA from './form/actions'
import * as portfoliosA from './portfolios/actions'
import * as ui from './ui/actions'

import * as appS from './app/selectors'
import * as portfoliosS from './portfolios/selectors'

export const appActions = app
export const formActions = formA
export const portfoliosActions = portfoliosA
export const uiActions = ui

export const appSelectors = appS
export const portfoliosSelectors = portfoliosS

export default (deps, appInsights) =>
  createStore(
    reducer,
    appInsights,
    composeWithDevTools(
      applyMiddleware(
        inject(deps),

        handleOpenLink,
        handleFuture,
        handleOpenLinkHere,
      ),
    )
  )



// WEBPACK FOOTER //
// ./src/store/index.js